module.exports = __webpack_public_path__ + "files/719b2ce27f1819d70d9c7bd6b155ff7c.png";